import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './DJCVSearch.css';

function DJCVSearch({ tableData }) {
    return (
        <div className="DJCV_search-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No se encontraron resultados para DJCV</h4>
            )}
        </div>
    );
}

export default DJCVSearch;
